import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { adminLogin } from "../../services/adminService";
import "../../styles/admin.css";

function AdminLogin() {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Admin Login - BusinessNearMe";
  }, []);

  const [form, setForm] = useState({
    email: "",
    password: ""
  });

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.email || !form.password) {
      setError("Please fill all fields");
      return;
    }

    try {
      setLoading(true);
      setError("");

      const data = await adminLogin(
        form.email,
        form.password
      );

      // ✅ save token
      localStorage.setItem("adminToken", data.token);

      // ✅ redirect
      navigate("/admin");

    } catch (err) {
      setError(
        err?.response?.data?.msg ||
        "Invalid credentials"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-page">
      <form className="admin-login-card" onSubmit={handleSubmit}>
        
        <h2>Admin Login</h2>

        <input
          type="email"
          name="email"
          placeholder="Admin Email"
          value={form.email}
          onChange={handleChange}
        />

        <input
          type="password"
          name="password"
          placeholder="Password"
          value={form.password}
          onChange={handleChange}
        />

        <button type="submit" disabled={loading}>
          {loading ? "Logging in..." : "Login"}
        </button>

        {error && (
          <p className="login-error">
            {error}
          </p>
        )}
      </form>
    </div>
  );
}

export default AdminLogin;